import { render, staticRenderFns } from "./ProductShare.vue?vue&type=template&id=1147b2cf&scoped=true&lang=html&"
import script from "./ProductShare.vue?vue&type=script&lang=js&"
export * from "./ProductShare.vue?vue&type=script&lang=js&"
import style0 from "./ProductShare.vue?vue&type=style&index=0&id=1147b2cf&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1147b2cf",
  null
  
)

export default component.exports